import { useNewDeviceModelWidgets } from '@portals/api/partners';

export function useIsLegacyWidgets(modelId: string): {
  isLoading: boolean;
  isLegacy: boolean;
} {
  const deviceWidgets = useNewDeviceModelWidgets(modelId);

  if (!deviceWidgets.isFetched)
    return {
      isLoading: true,
      isLegacy: false,
    };

  if (deviceWidgets.data === null) {
    return {
      isLoading: false,
      isLegacy: true,
    };
  }

  return {
    isLoading: false,
    isLegacy: false,
  };
}
